// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LogistRoutes.module.css */

/* Переменные цветов */
:root {
  --primary-color: #007bff;
  --secondary-color: #f8f9fa;
  --text-color: #333;
  --status-open: #007bff;
  --status-closed: #28a745;
  --status-not-delivered: #dc3545;
  --status-pending: #ffc107;
}

/* Общий контейнер */
.LogistRoutes_logistContainer__FuO22 {
  display: flex;
  height: 100%;
  background-color: var(--secondary-color);
  overflow: hidden;
}

/* Боковая панель */
.LogistRoutes_logistSidebar__QMzM4 {
  width: 330px;
  background: #fff;
  padding: 20px;
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
  overflow-y: auto;
}

/* Фильтр дат */
.LogistRoutes_logistDateFilterRow__DS7XD {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.LogistRoutes_logistDateFilterRow__DS7XD label {
  flex: 1 1 auto;
  min-width: 100px;
  font-size: 14px;
}
.LogistRoutes_logistDateFilterRow__DS7XD input[type="date"] {
  margin-left: 6px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100px;
  max-width: 100%;
}

/* Список маршрутов */
.LogistRoutes_routesList__PKywv {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}
.LogistRoutes_routeItem__9QnhJ {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  transition: background-color 0.2s;
}

.LogistRoutes_selected__h5-GQ {
  background-color: var(--primary-color);
  color: #fff;
}

/* Кнопка закрыть/открыть маршрут */
.LogistRoutes_closeRouteButton__zRt9U {
  margin-top: 6px;
  padding: 6px 12px;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.LogistRoutes_open__73\\+EZ {
  background-color: var(--status-open);
  color: #fff;
}
.LogistRoutes_closed__2eDMf {
  background-color: var(--status-closed);
  color: #fff;
}

/* Прогресс-бар */
.LogistRoutes_progressContainer__TJQOP {
  width: 100%;
  height: 8px;
  background: #eee;
  border-radius: 4px;
  margin: 8px 0;
}
.LogistRoutes_progressBar__go\\+zd {
  display: flex;
  height: 10px;       /* как у диспетчера */
  border-radius: 4px;
  overflow: hidden;
}

.LogistRoutes_progressDelivered__TPF34 {
  background-color: rgb(40, 167, 69);
  transition: width 0.3s ease;
}

.LogistRoutes_progressInProgress__\\+GHlW {
  background-color: rgb(0, 123, 255);
  transition: width 0.3s ease;
}

.LogistRoutes_progressUndelivered__3lmDc {
  background-color: rgb(220, 53, 69);
  transition: width 0.3s ease;
}

.LogistRoutes_statusText__oF6j8 {
  font-size: 15px;
  text-align: right;
  margin-top: 1px;
  color: var(--text-color);
}

/* Основная область */
.LogistRoutes_routeDetails__iqXIf {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}

/* Переключатели вида и курьеров */
.LogistRoutes_viewToggle__JNYyC {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}
.LogistRoutes_smallButton__gjYlt {
  padding: 6px 12px;
  border: 1px solid var(--primary-color);
  background: #fff;
  color: var(--primary-color);
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}
.LogistRoutes_smallButton__gjYlt:hover {
  background: var(--primary-color);
  color: #fff;
}

/* Настройка колонок */
.LogistRoutes_columnSettings__X7Ftw {
  margin: 16px 0;
}

/* Таблица квитанций */
.LogistRoutes_logistReceiptsTable__jFjqB {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.LogistRoutes_logistReceiptsTable__jFjqB th,
.LogistRoutes_logistReceiptsTable__jFjqB td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 0.9rem;
}
.LogistRoutes_logistReceiptsTable__jFjqB th {
  background: var(--primary-color);
  color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.LogistRoutes_logistReceiptsTable__jFjqB th:hover {
  background: #0056b3;
}

/* Стиль для ячейки статуса */
.LogistRoutes_statusCell__jR-M4 {
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  padding: 4px;
}

/* Поле «нет результатов» */
.LogistRoutes_noResults__rgiWN {
  text-align: center;
  padding: 20px;
  color: #888;
}

/* Карта */
.LogistRoutes_logistMapContainer__A81Mk {
  height: calc(100% - 32px);
}
.LogistRoutes_logistLeafletContainer__t3xji {
  width: 100%;
  height: 100%;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
  .LogistRoutes_logistContainer__FuO22 {
    flex-direction: column;
  }
  .LogistRoutes_logistSidebar__QMzM4 {
    width: 100%;
    max-height: 200px;
  }
  .LogistRoutes_routesList__PKywv {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .LogistRoutes_routeDetails__iqXIf {
    padding: 12px;
  }
  .LogistRoutes_logistReceiptsTable__jFjqB,
  .LogistRoutes_logistReceiptsTable__jFjqB thead {
    display: block;
  }
  .LogistRoutes_logistReceiptsTable__jFjqB tbody {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .LogistRoutes_logistReceiptsTable__jFjqB tr {
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 6px;
    background: #fff;
  }
  .LogistRoutes_logistReceiptsTable__jFjqB td {
    border: none;
    text-align: left;
    padding: 4px 0;
  }
  .LogistRoutes_logistReceiptsTable__jFjqB td:first-child {
    font-weight: bold;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/LogisistMainPage/styles/LogistRoutes.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,sBAAsB;AACtB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;AACd;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY,QAAQ,qBAAqB;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;;IAEE,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* LogistRoutes.module.css */\r\n\r\n/* Переменные цветов */\r\n:root {\r\n  --primary-color: #007bff;\r\n  --secondary-color: #f8f9fa;\r\n  --text-color: #333;\r\n  --status-open: #007bff;\r\n  --status-closed: #28a745;\r\n  --status-not-delivered: #dc3545;\r\n  --status-pending: #ffc107;\r\n}\r\n\r\n/* Общий контейнер */\r\n.logistContainer {\r\n  display: flex;\r\n  height: 100%;\r\n  background-color: var(--secondary-color);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Боковая панель */\r\n.logistSidebar {\r\n  width: 330px;\r\n  background: #fff;\r\n  padding: 20px;\r\n  box-shadow: 2px 0 10px rgba(0,0,0,0.1);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Фильтр дат */\r\n.logistDateFilterRow {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n.logistDateFilterRow label {\r\n  flex: 1 1 auto;\r\n  min-width: 100px;\r\n  font-size: 14px;\r\n}\r\n.logistDateFilterRow input[type=\"date\"] {\r\n  margin-left: 6px;\r\n  padding: 4px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 100px;\r\n  max-width: 100%;\r\n}\r\n\r\n/* Список маршрутов */\r\n.routesList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  flex-grow: 1;\r\n}\r\n.routeItem {\r\n  padding: 10px;\r\n  border-bottom: 1px solid #ddd;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.selected {\r\n  background-color: var(--primary-color);\r\n  color: #fff;\r\n}\r\n\r\n/* Кнопка закрыть/открыть маршрут */\r\n.closeRouteButton {\r\n  margin-top: 6px;\r\n  padding: 6px 12px;\r\n  font-size: 0.85rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.open {\r\n  background-color: var(--status-open);\r\n  color: #fff;\r\n}\r\n.closed {\r\n  background-color: var(--status-closed);\r\n  color: #fff;\r\n}\r\n\r\n/* Прогресс-бар */\r\n.progressContainer {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: #eee;\r\n  border-radius: 4px;\r\n  margin: 8px 0;\r\n}\r\n.progressBar {\r\n  display: flex;\r\n  height: 10px;       /* как у диспетчера */\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progressDelivered {\r\n  background-color: rgb(40, 167, 69);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.progressInProgress {\r\n  background-color: rgb(0, 123, 255);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.progressUndelivered {\r\n  background-color: rgb(220, 53, 69);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.statusText {\r\n  font-size: 15px;\r\n  text-align: right;\r\n  margin-top: 1px;\r\n  color: var(--text-color);\r\n}\r\n\r\n/* Основная область */\r\n.routeDetails {\r\n  flex: 1;\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Переключатели вида и курьеров */\r\n.viewToggle {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n}\r\n.smallButton {\r\n  padding: 6px 12px;\r\n  border: 1px solid var(--primary-color);\r\n  background: #fff;\r\n  color: var(--primary-color);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n}\r\n.smallButton:hover {\r\n  background: var(--primary-color);\r\n  color: #fff;\r\n}\r\n\r\n/* Настройка колонок */\r\n.columnSettings {\r\n  margin: 16px 0;\r\n}\r\n\r\n/* Таблица квитанций */\r\n.logistReceiptsTable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: #fff;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\r\n}\r\n.logistReceiptsTable th,\r\n.logistReceiptsTable td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n}\r\n.logistReceiptsTable th {\r\n  background: var(--primary-color);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n.logistReceiptsTable th:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n/* Стиль для ячейки статуса */\r\n.statusCell {\r\n  color: #fff;\r\n  font-weight: bold;\r\n  border-radius: 4px;\r\n  padding: 4px;\r\n}\r\n\r\n/* Поле «нет результатов» */\r\n.noResults {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #888;\r\n}\r\n\r\n/* Карта */\r\n.logistMapContainer {\r\n  height: calc(100% - 32px);\r\n}\r\n.logistLeafletContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* Мобильная адаптация */\r\n@media (max-width: 768px) {\r\n  .logistContainer {\r\n    flex-direction: column;\r\n  }\r\n  .logistSidebar {\r\n    width: 100%;\r\n    max-height: 200px;\r\n  }\r\n  .routesList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n  }\r\n  .routeDetails {\r\n    padding: 12px;\r\n  }\r\n  .logistReceiptsTable,\r\n  .logistReceiptsTable thead {\r\n    display: block;\r\n  }\r\n  .logistReceiptsTable tbody {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  .logistReceiptsTable tr {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    background: #fff;\r\n  }\r\n  .logistReceiptsTable td {\r\n    border: none;\r\n    text-align: left;\r\n    padding: 4px 0;\r\n  }\r\n  .logistReceiptsTable td:first-child {\r\n    font-weight: bold;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logistContainer": `LogistRoutes_logistContainer__FuO22`,
	"logistSidebar": `LogistRoutes_logistSidebar__QMzM4`,
	"logistDateFilterRow": `LogistRoutes_logistDateFilterRow__DS7XD`,
	"routesList": `LogistRoutes_routesList__PKywv`,
	"routeItem": `LogistRoutes_routeItem__9QnhJ`,
	"selected": `LogistRoutes_selected__h5-GQ`,
	"closeRouteButton": `LogistRoutes_closeRouteButton__zRt9U`,
	"open": `LogistRoutes_open__73+EZ`,
	"closed": `LogistRoutes_closed__2eDMf`,
	"progressContainer": `LogistRoutes_progressContainer__TJQOP`,
	"progressBar": `LogistRoutes_progressBar__go+zd`,
	"progressDelivered": `LogistRoutes_progressDelivered__TPF34`,
	"progressInProgress": `LogistRoutes_progressInProgress__+GHlW`,
	"progressUndelivered": `LogistRoutes_progressUndelivered__3lmDc`,
	"statusText": `LogistRoutes_statusText__oF6j8`,
	"routeDetails": `LogistRoutes_routeDetails__iqXIf`,
	"viewToggle": `LogistRoutes_viewToggle__JNYyC`,
	"smallButton": `LogistRoutes_smallButton__gjYlt`,
	"columnSettings": `LogistRoutes_columnSettings__X7Ftw`,
	"logistReceiptsTable": `LogistRoutes_logistReceiptsTable__jFjqB`,
	"statusCell": `LogistRoutes_statusCell__jR-M4`,
	"noResults": `LogistRoutes_noResults__rgiWN`,
	"logistMapContainer": `LogistRoutes_logistMapContainer__A81Mk`,
	"logistLeafletContainer": `LogistRoutes_logistLeafletContainer__t3xji`
};
export default ___CSS_LOADER_EXPORT___;
